export default __webpack_public_path__ + "static/media/mess.e2ac7851.svg";